import React, {useState} from "react";
import {Route} from "@/routing/Router";
import {useRestaurant} from "@/context/restaurant/RestaurantProvider";
import {useQuery} from "@tanstack/react-query";
import {api} from "@/data/api";
import {formatLocalDate} from "@/utils/DateUtils";
import DayReportPageHeading from "@widgets/reports/dayReport/heading/DayReportPageHeading";
import DayReportDayPicker from "@widgets/reports/dayReport/dayPicker/DayReportDayPicker";
import DayReportDashboard from "@widgets/reports/dayReport/DayReportDashboard";
import ExportDayReportModal from "@widgets/reports/dayReport/export/ExportDayReportModal";
import {DAY_REPORT_QUERY_KEY} from "@widgets/reports/dayReport/DayReportUtils";
import useReportDayParam from "./dayPicker/useReportDayParam";

type Props = {
    route: Route,
};

const DayReportOverview = ({route}: Props) => {
    const {dashboardLocation} = useRestaurant();
    const [showDatePicker, setShowDatePicker] = useState(false);
    const [showExportModal, setShowExportModal] = useState(false);
    const [selectedDay, setSelectedDay] = useReportDayParam();
    const day: string = formatLocalDate(selectedDay);
    const {data, isFetching, isError} = useQuery({
        queryKey: [DAY_REPORT_QUERY_KEY, dashboardLocation.id, day],
        queryFn: () => api.dayReport.getDayReport(dashboardLocation.id, day),
    });

    return (
        <>
            <DayReportPageHeading
                route={route}
                selectedDay={selectedDay}
                setShowDatePicker={setShowDatePicker}
                setShowExportModal={setShowExportModal}
                dataLoading={isFetching}
            />

            <div className={"mt-6 md:mt-12"}>
                <DayReportDashboard
                    dayReport={data}
                    isFetching={isFetching}
                    isError={isError}
                    setShowExportModal={setShowExportModal}
                />
            </div>

            <DayReportDayPicker
                showDatePicker={showDatePicker}
                setShowDatePicker={setShowDatePicker}
                selectedDay={selectedDay}
                setSelectedDay={setSelectedDay}
            />

            <ExportDayReportModal
                dayReport={data}
                show={showExportModal}
                setShow={setShowExportModal}
            />
        </>
    );
};

export default DayReportOverview;